import { render, staticRenderFns } from "./OrdersRoundFilter.vue?vue&type=template&id=47dcb612&"
import script from "./OrdersRoundFilter.vue?vue&type=script&lang=js&"
export * from "./OrdersRoundFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports